import { AfterViewInit, Component, ViewChild, Input } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { GroupsService } from '../../../services/groups.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

export interface groupResourceData {
    id: string,
    fileTitle: string,
    fileDescription: string,
    fileName: string,
    fileExtension: string,
    filePath: string,
    addedById: string,
    addedByName: string,
    addedByOrganization: string,
    createdDate: string
}


@Component({
  selector: 'app-groups-resource-list',
  templateUrl: './groups-resource-list.component.html',
  styleUrls: ['./groups-resource-list.component.scss']
})
export class GroupsResourceListComponent implements AfterViewInit {


    @Input() groupId: string = "0";

    displayedColumns: string[] = ['title', 'type', 'user', 'date'];
    dataSource: MatTableDataSource<groupResourceData>;

    @ViewChild(MatPaginator)
    paginator!: MatPaginator;
    @ViewChild(MatSort)
    sort!: MatSort;



    resourceList: Array<groupResourceData> = [];

    loadingMessage: string = "Loading...";

    constructor(private route: ActivatedRoute,
        private router: Router, private groupsService: GroupsService,
        private authentication: AuthenticationService,
        private common: CommonService) {
        this.dataSource = new MatTableDataSource(this.resourceList);

    }

    ngAfterViewInit(): void {
        this.getGroupFiles(this.groupId, 1);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    clickedRows(row: any) {
        var link = document.createElement('a');
        link.href = row.filePath;
        link.target = "_blank";
        var fileName = row.fileName;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    }

    getGroupFiles(groupId: any, page: any) {

        this.groupsService.getGroupFiles(groupId, page).subscribe(
            (res: any) => {

                for (var i = 0; i < res.length; i++) {

                    var file: groupResourceData = {
                        addedById: res[i].addedUser.id,
                        addedByName: res[i].addedUser.firstName + ' ' + res[i].addedUser.lastName,
                        addedByOrganization: res[i].addedUser.portalAccount.name,
                        createdDate: res[i].createdDate,
                        fileDescription: res[i].fileDescription,
                        fileExtension: res[i].fileExtension,
                        fileName: res[i].fileName,
                        filePath: res[i].filePath,
                        fileTitle: res[i].fileTitle,
                        id: res[i].groupFileId
                    }

                    this.resourceList.push(file);
                }
                this.dataSource = new MatTableDataSource(this.resourceList);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.loadingMessage = "No resources found";
                if (res.length > 0)
                    this.getGroupFiles(groupId, page + 1);

            },
            (err: any) => {
                console.error("groups files error", err);
            }
        );
    }

}
